import React from 'react';



import "./Testimonials.css";

function Testimonials() {



  return (
    <section className="testimonials bg-color">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="sub-title">Businesses Grow Better with CDM</h2>
            <hr />
          </div>
        </div>
        <div className="row">
          <div className="col-md-5"></div>
          <div className="col-md-7">
            <h2 className="main-title split-text">
              Accelerating growth, and unlocking new potential. Let’s build your brand—together.
            </h2>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Testimonials;

